import React, { Component } from "react";
import Select from "react-select3";
import _ from "lodash";
import request from "superagent";

export default class SharepointFolderSelector extends Component {
  static defaultProps = {
    connectionId: null,
    selectedDrive: null,
    onSelectFolder: null,
    folderPath: [],
  }

  state = {
    folders: [],
    selectedFolderPath: this.props.folderPath || [],
    selectedFolder: (this.props.folderPath || []).slice(-1)[0] || null,
    isLoading: false,
    isError: false,
  }

  async loadFolders() {
    const { connectionId, selectedDrive } = this.props;
    const { selectedFolder } = this.state;

    // can't load folders unless a drive is selected
    if (!selectedDrive) {
      this.setState({ folders: [] });
      return;
    }

    // if we have a selected folder, and its id is null, do nothing.  This is a legacy folder where we don't
    // yet know the real id.
    if (selectedFolder && !selectedFolder.id)
      return;

    this.setState({ isError: false, isLoading: true });

    try {
      const response = await request.get(`/rpc/integrations/connections/${connectionId}/sharepoint/list-folder`)
        .query({ drive: selectedDrive.id, parent_id: _.get(selectedFolder, 'id') });

      this.setState({ folders: _.get(response.body, 'folders', [])});
    }
    catch (error) {
      console.error("Failed to load sharepoint folder list: ", error);
      this.setState({ isError: true });
    }
    finally {
      this.setState({ isLoading: false });
    }
  }

  isLegacyFolderPath() {
    const { selectedFolderPath } = this.state;

    if (selectedFolderPath === null)
      return false;

    if (selectedFolderPath.length === 0)
      return false;

    return !selectedFolderPath[0].id;
  }

  // For the current folder item, returns the full/path/to/the/folder string
  folderPathName(folder) {
    const { selectedFolderPath } = this.state;

    // if this is just hte legacy folder path that we loaded in, just return the path name.
    if (this.isLegacyFolderPath()) {
      return selectedFolderPath.map(folder => folder.name).join('/');
    }

    // filter out the selected folder from the selected folder path to get the path.
    const pathToFolder = selectedFolderPath.filter(item => { return item.id !== folder.id });

    // this is a top level folder, just return the name
    if (pathToFolder.length === 0)
      return folder.name;

    // return full path to the folder
    return pathToFolder.map(folder => folder.name).join('/')
      + '/' + folder.name;
  };

  componentDidMount() {
    this.loadFolders();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (_.get(prevProps, 'selectedDrive.id') !== _.get(this.props, 'selectedDrive.id')) {
      // when the drive selection changes, we must clear folder selection and reload folders
      await this.setState({
        selectedFolder: null,
        selectedFolderPath: [],
      });

      await this.loadFolders();
    }
  }

  render() {
    const {
      folders,
      isError,
      isLoading,
      selectedFolder,
      selectedFolderPath,
    } = this.state;

    const {
      isDisabled,
      onSelectFolder,
    } = this.props;

    if (isError) {
      return <div className="alert alert-danger">Failed to load sharepoint folders</div>;
    }

    return (
      <Select
        placeholder="Select subfolder (optional)"
        isDisabled={isDisabled}
        value={selectedFolder}
        options={folders}
        isLoading={isLoading}
        getOptionLabel={folder => this.folderPathName(folder)}
        getOptionValue={folder => folder.id}
        noOptionsMessage={() => "No subfolders available"}
        isClearable
        key="select-sharepoint-folder"
        onChange={async (option) => {
          // if the value was cleared, clear the path to the folder
          const newSelectedFolderPath = option === null
            ? []
            : [...selectedFolderPath, option];

          await this.setState({
            selectedFolderPath: newSelectedFolderPath,
            selectedFolder: option,
          });

          await this.loadFolders();

          // communicate the new folder list to the containing component
          if (onSelectFolder)
            onSelectFolder({ folderPath: newSelectedFolderPath });
        }}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/Integrations/connections/SharepointFolderSelector.jsx